import React, { lazy } from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
// import { Campaign, CampaignManagements } from './components';
const Campaign = lazy(()=> import(/* webpackChunkName: "Campaign" */'./components/Campaign'));
const CampaignManagements = lazy(()=> import(/* webpackChunkName: "CampaignManagements" */'./components/CampaignManagements'));

const createForm = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  return <CampaignManagements mode="create" type={queryParams.type} />;
};

const editForm = ({ match }) => {
  return <CampaignManagements mode="edit" campaignId={match.params._id} />;
};

const routes = () => {
  return (
    <React.Fragment>
      <PrivateRoute
        key="/campaigns"
        exact={true}
        path="/campaigns"
        component={Campaign}
      />

      <PrivateRoute
        key="/campaigns/create"
        exact={true}
        path="/campaigns/create"
        component={createForm}
      />

      <PrivateRoute
        key="/campaigns/edit"
        exact={true}
        path="/campaigns/edit/:_id"
        component={editForm}
      />
    </React.Fragment>
  );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/campaign/Campaign/routes.js